module.exports = __webpack_public_path__ + "static/media/finakl_blue_01.a0a63ddc.png";